import { BACKEND_URL } from '@/config/api';
// src/components/Author/AuthorProfileSnippet.jsx
import React from 'react';
import { User } from 'lucide-react';

const AuthorProfileSnippet = ({ author, onViewFullProfile }) => {
  if (!author) return null;

  const displayName = author.pen_name || `${author.first_name} ${author.last_name}`;
  const bioText = author.tagline || author.short_bio || '';
  const truncatedBio = bioText.length > 150 ? bioText.substring(0, 150) + '...' : bioText;

  return (
    <div className="flex items-start gap-4 p-4 bg-slate-800/50 rounded-lg border border-slate-700">
      {/* Headshot */}
      {author.headshot_image_url ? (
        <img
          src={`${BACKEND_URL}${author.headshot_image_url}`}
          alt={displayName}
          className="h-16 w-16 rounded-full object-cover border-2 border-purple-500/50 flex-shrink-0 cursor-pointer hover:border-purple-400 transition-colors"
          onClick={onViewFullProfile}
          title="View author profile"
        />
      ) : (
        <div 
          className="h-16 w-16 rounded-full bg-slate-700 border-2 border-purple-500/50 flex items-center justify-center flex-shrink-0 cursor-pointer hover:border-purple-400 transition-colors"
          onClick={onViewFullProfile}
          title="View author profile"
        >
          <User className="h-8 w-8 text-slate-400" />
        </div>
      )}

      {/* Author Info */}
      <div className="flex-1 min-w-0">
        <button
          onClick={onViewFullProfile}
          className="text-base sm:text-lg font-semibold text-white hover:text-purple-300 transition-colors mb-1 text-left"
          title="View full author profile"
        >
          {displayName}
        </button>
        {truncatedBio && (
          <p className="text-sm text-slate-300 leading-relaxed mb-3">
            {truncatedBio}
          </p>
        )}
        {onViewFullProfile && (
          <button
            onClick={onViewFullProfile}
            className="inline-flex items-center gap-2 px-4 py-2 bg-purple-600 hover:bg-purple-500 text-white text-sm font-semibold rounded-lg transition-colors shadow-lg shadow-purple-900/30"
          >
            <span>View Full Author Profile</span>
            <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

export default AuthorProfileSnippet;
